import { ABU } from "@client";
import { css } from "@emotion/css";
import { Live2dDelegateV2 } from "./Live2dDelegateV2";
import { NpcModel } from "./src/LAppDefine";

export { NpcModel };

export const Npc = new (class {
  mountNode: HTMLCanvasElement;

  init() {
    this.mountNode = document.body.appendChild(document.createElement("canvas"));
    this.mountNode.width = this.mountNode.height = 250;
    this.mountNode.className = css`
      position: fixed;
      right: 0;
      bottom: 0;
      z-index: 1000;
    `;
    Live2dDelegateV2.init(`${ABU}live2d/`, Npc.mountNode);
    this.setModel(NpcModel.RentHouse);
    this.setVisible(false);
  }

  setVisible(visible: boolean) {
    Live2dDelegateV2.Instance.showTalk();
    this.mountNode.style.display = visible ? "block" : "none";
  }

  setModel(model: NpcModel) {
    Live2dDelegateV2.Instance.changeModel(model);
  }
})();
